import src from "IMAGE";
export default { src, width: 194, height: 193, blurWidth: 0, blurHeight: 0};
